/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LinkPipedriveDealInput = {|
  projectId?: ?string,
  dealId?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type LinkPipedriveDealMutationVariables = {|
  input: LinkPipedriveDealInput
|};
export type LinkPipedriveDealMutationResponse = {|
  +linkPipedriveDeal: ?{|
    +project: ?{|
      +pipedriveDeal: ?string
    |}
  |}
|};
export type LinkPipedriveDealMutation = {|
  variables: LinkPipedriveDealMutationVariables,
  response: LinkPipedriveDealMutationResponse,
|};
*/


/*
mutation LinkPipedriveDealMutation(
  $input: LinkPipedriveDealInput!
) {
  linkPipedriveDeal(input: $input) {
    project {
      pipedriveDeal
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "LinkPipedriveDealInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pipedriveDeal",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LinkPipedriveDealMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LinkPipedriveDealPayload",
        "kind": "LinkedField",
        "name": "linkPipedriveDeal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LinkPipedriveDealMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LinkPipedriveDealPayload",
        "kind": "LinkedField",
        "name": "linkPipedriveDeal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "LinkPipedriveDealMutation",
    "operationKind": "mutation",
    "text": "mutation LinkPipedriveDealMutation(\n  $input: LinkPipedriveDealInput!\n) {\n  linkPipedriveDeal(input: $input) {\n    project {\n      pipedriveDeal\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c1606868eae977de36c41cbee466438c';

module.exports = node;
